import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as _ from 'underscore';

import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { skip } from 'rxjs/operators';

import { StorageSessionService } from '../../../core/storage/services/storage.session.service';
import { EmitterService } from '../../../core/utility/services/emitter.service';
import { Configuration, NAVIGATION_REQUEST_STATUSES } from '../../analytics-core/interfaces/configuration.interface';
import { QueryParameters } from '../../analytics-core/interfaces/query-parameters.interface';
import { Widget } from '../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../analytics-core/services/color.utility.service';
import { DATEPICKER, EVENT_EMITTERS, OPTIONS, PATHS, PRINTABLE_ACCESS_KEYS } from '../constants/analytics.constants';
import { AnalyticsDataModel } from '../models/analytics.datamodel';
import { AnalyticsService } from '../services/analytics.service';
import { UtilityService } from '../../../core/utility/services/utility.service';

@Component({
	selector: 'app-analytics',
	styleUrls: ['../styles/analytics.component.css'],
	templateUrl: '../views/analytics.component.html'
})
export class AnalyticsComponent implements OnInit, AfterContentChecked {
	public config: Configuration = {} as Configuration;
	public password = '';
	public newPassword = '';
	public confirmPassword = '';
	public errorMessage;
	public invalidInput = false;
	public invalidPassword = false;
	private newPasswordLength = 6;
	private navigationItemStatus = {};
	private timeIntervalFn: any;
	private campaignsRequestCounter = 0;
	private $navigationProcessRequestInterval: any;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private analyticsDataModel: AnalyticsDataModel,
		private analyticsService: AnalyticsService,
		private storageSessionService: StorageSessionService,
		private colorUtilityService: ColorUtilityService
	) {
		EmitterService.get(EVENT_EMITTERS.NAVIGATE).subscribe((res) => {
			this.$navigationProcessRequestInterval = setInterval(() => {
				const allNavigationStatusComplete = _.reduce(
					this.analyticsDataModel.navigateProcessRequestStatus,
					(result: boolean, navigationStatus: NAVIGATION_REQUEST_STATUSES) => {
						return navigationStatus === NAVIGATION_REQUEST_STATUSES.COMPLETED && result;
					},
					true
				);
				if (allNavigationStatusComplete) {
					this.validateBeforeNavigation(res);
					clearInterval(this.$navigationProcessRequestInterval);
				}
			}, 500);
		});
		EmitterService.get(EVENT_EMITTERS.ADVERTISERS).subscribe((response: any) => {
			this.analyticsDataModel.selectedAdvertisers = response;
			EmitterService.get(EVENT_EMITTERS.CAMPAIGN_LOADED).emit(false);
			this.validate();
			this.campaignsRequestCounter++;
			EmitterService.get(EVENT_EMITTERS.CAMPAIGN_REQUEST_COUNTER).emit(this.campaignsRequestCounter);
			this.analyticsService.getCampaignData(this.getAdvertiserIds(response)).subscribe(
				(res: any) => {
					this.checkIsPrintable(res.campaigns);
					this.campaignsRequestCounter--;
					EmitterService.get(EVENT_EMITTERS.CAMPAIGN_REQUEST_COUNTER).emit(this.campaignsRequestCounter);
					if (res.success) {
						this.analyticsDataModel.campaignsData = res.campaigns;
					} else {
						this.analyticsDataModel.campaignsData = [];
						this.analyticsDataModel.selectedCampaigns = [];
					}
					this.updateQueryParams();
					EmitterService.get(EVENT_EMITTERS.CAMPAIGN_LOADED).emit(true);
				},
				(err) => {
					this.campaignsRequestCounter--;
					EmitterService.get(EVENT_EMITTERS.CAMPAIGN_REQUEST_COUNTER).emit(this.campaignsRequestCounter);
				}
			);
		});
		/* ignoring the inital execution of the callback function */
		EmitterService.get(EVENT_EMITTERS.CAMPAIGNS)
			.pipe(skip(1))
			.subscribe((response: any) => {
				this.checkIsPrintable(response);
				this.analyticsDataModel.selectedCampaigns = response;
				this.updateQueryParams(true);
				this.analyticsDataModel.queryParamsCampaigns = this.analyticsDataModel.selectedCampaigns.map(
					(cmp) => cmp.campaignId
				);
				EmitterService.get(EVENT_EMITTERS.SELECTED_CAMPAIGN_LOADED).emit(true);
				EmitterService.get(EVENT_EMITTERS.PRODUCT_DOWNLOAD_STATUS_CHECK).emit(true);
				this.validate();
			});
		EmitterService.get(EVENT_EMITTERS.DATE_RANGE).subscribe((response: any) => {
			this.checkIsPrintable(this.analyticsDataModel.selectedCampaigns);
			this.analyticsDataModel.startDate = response.startDate;
			this.analyticsDataModel.endDate = response.endDate;
			this.updateQueryParams();
			EmitterService.get(EVENT_EMITTERS.PRODUCT_DOWNLOAD_STATUS_CHECK).emit(true);
			this.validate();
		});
		EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).subscribe((response: any) => {
			this.checkIsPrintable(this.analyticsDataModel.selectedCampaigns);
			this.navigationItemStatus = {};
			this.hideNoDataContent();
			this.analyticsService
				.getCampaignData(this.getAdvertiserIds(this.analyticsDataModel.selectedAdvertisers))
				.subscribe((campaignResponse: any) => {
					if (campaignResponse.success && campaignResponse.campaigns) {
						this.analyticsDataModel.campaignsDataWithoutPreselect = campaignResponse.campaigns;
						EmitterService.get(EVENT_EMITTERS.REFRESH_CAMPAIGNS).emit(campaignResponse.campaigns);
						this.hideNoDataTextR10();
					} else {
						this.analyticsDataModel.campaignsData = [];
						this.analyticsDataModel.selectedCampaigns = [];
						this.showNoDataTextR10();
					}
					EmitterService.get(EVENT_EMITTERS.RELOAD).emit(true);
				});
		});
		EmitterService.get(EVENT_EMITTERS.LOGOUT).subscribe((response: any) => {
			this.analyticsService.logout().subscribe((res: any) => {
				if (res.success) {
					this.storageSessionService.clearToken();
					this.storageSessionService.clearServiceURL();
					this.clearData();
					this.router.navigate([PATHS.LOGIN]);
				}
			});
		});
		EmitterService.get(EVENT_EMITTERS.CHANGE_PASSWORD).subscribe((response: any) => {
			this.clearChangePasswordForm();
			jQuery('.modal-wrapper').addClass('open');
		});
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_STATUS).subscribe((response: any) => {
			this.navigationItemStatus[response.path] = response.isDisabled;
		});
		EmitterService.get(EVENT_EMITTERS.TOGGLE_LAYOUT).subscribe((response: any) => {
			if (response) {
				// jQuery('#layout').switchClass('main-layout', 'hidden-layout', 1000, 'easeInOutQuad');
				jQuery('#layout').removeClass(['main-layout', '1000', 'easeOutBounce']);
				jQuery('#layout').addClass(['hidden-layout', '1000', 'easeOutBounce']);
			} else {
				// jQuery('#layout').switchClass('hidden-layout', 'main-layout', 1000, 'easeInOutQuad');
				jQuery('#layout').removeClass(['hidden-layout', '1000', 'easeOutBounce']);
				jQuery('#layout').addClass(['main-layout', '1000', 'easeOutBounce']);
			}
		});
		EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE).subscribe((response) => {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE_WIDGET).emit(response);
		});
	}

	ngOnInit(): void {
		this.config = this.analyticsDataModel.config;
		const urls = this.router.url.split('/');
		this.analyticsDataModel.preSelectAdvertisers(OPTIONS.ADVERTISERS.DEFAULT_SELECTION);
		const childPath = urls[urls.length - 1].split('?')[0];
		const configProductPath = this.config.products.map((obj) => obj.productURL);
		if (childPath === 'dashboard' || !configProductPath.includes(childPath)) {
			this.router.navigate(['/dashboard/' + this.config.routing.defaultRoute], { queryParams: this.setQueryParams() });
		}
		this.analyticsDataModel.setCurrentPath(this.router.url.split('/')[1].split('?')[0]);
	}

	ngAfterContentChecked(): void {
		if (!this.analyticsDataModel.selectedAdvertisers.length) {
			this.showNoDataTextR10();
		}
	}

	checkIsPrintable(campaigns: any): void {
		if (campaigns) {
			const permissionKeys = {};
			Object.keys(PRINTABLE_ACCESS_KEYS).forEach((key) => {
				const count = campaigns.reduce((sum, campaign) => {
					if (campaign.permission.includes(PRINTABLE_ACCESS_KEYS[key])) {
						// tslint:disable-next-line: no-parameter-reassignment
						return (sum += 1);
					}
					return sum;
				}, 0);
				permissionKeys[key] = count > 0 && count <= 12 ? count : 0;
			});
			this.analyticsDataModel.printableReport = [permissionKeys, campaigns];
			EmitterService.get(EVENT_EMITTERS.PRINTABLE_PERMISSIONS).emit([permissionKeys, campaigns]);
		}
	}

	getAdvertiserIds(selectedAdvertisers: any): any {
		const advertiserIds = _.pluck(selectedAdvertisers, 'id');
		return advertiserIds;
	}

	validateBeforeNavigation(response: any): void {
		const status = this.checkAllNavItemsAvailable();
		if (status) {
			this.validateAndNavigate(response);
		}
	}

	checkAllNavItemsAvailable(): boolean {
		let status = false;
		const navItems = _.keys(this.navigationItemStatus);
		const navWidgets = this.analyticsDataModel.config.navWidgets;

		if (
			UtilityService.isUndefinedOrNull(
				this.analyticsDataModel.config.products.filter((item) => item.productURL == 'overview')[0]?.printableReport
					?.strategyName
			)
		) {
			const overviewNavWidget = _.findWhere(navWidgets, { widgetPath: PATHS.OVERVIEW });
			if (overviewNavWidget) {
				const index = _.indexOf(navWidgets, overviewNavWidget);
				navWidgets.splice(index, 1);
			}
			if (navItems.length === this.analyticsDataModel.config.navWidgets.length) {
				status = true;
			}
		} else {
			if (
				this.analyticsDataModel.config.navWidgets.filter((item) => item.widgetPath == 'overview')?.length > 0 &&
				navItems.length + 1 === this.analyticsDataModel.config.navWidgets.length
			) {
				status = true;
			} else if (navItems.length === this.analyticsDataModel.config.navWidgets.length) {
				status = true;
			}
		}

		return status;
	}

	clearData(): void {
		setTimeout(() => {
			this.colorUtilityService.clearStylesFromHead();
			this.analyticsDataModel.selectedAdvertisers = [];
			this.analyticsDataModel.selectedCampaigns = [];
			this.analyticsDataModel.campaignsData = [];
			this.colorUtilityService.removeStyleSheets(this.config.styles);
		}, 500);
	}

	validate(): void {
		const validationStatus: boolean = this.validateSelectionData();
		EmitterService.get(EVENT_EMITTERS.VALIDATION).emit(validationStatus);
	}

	validateSelectionData(): boolean {
		const dateStatus: boolean = this.validateDates(this.analyticsDataModel.startDate, this.analyticsDataModel.endDate);
		return dateStatus;
	}

	validateDates(startDate: string, endDate: string): boolean {
		return moment(startDate).isSameOrBefore(moment(endDate));
	}

	closeChangePswdPopup(): void {
		jQuery('.modal-wrapper').removeClass('open');
	}

	changePassword(): void {
		if (this.password === '' || this.newPassword === '' || this.confirmPassword === '') {
			this.errorMessage = 'Please fill all the details.';
		} else {
			if (this.newPassword.length < this.newPasswordLength) {
				this.errorMessage = `Password must have ${this.newPasswordLength} characters.`;
				this.invalidPassword = true;
			} else if (this.newPassword !== this.confirmPassword) {
				this.errorMessage = 'New password and Confirm new password are not same.';
				this.invalidInput = true;
			} else {
				this.errorMessage = '';
				this.invalidInput = false;
				this.invalidPassword = false;
				const details = {
					new_password: this.newPassword,
					password: this.password
				};
				this.analyticsService.changePassword(details).subscribe(
					(res: any) => {
						if (res.success) {
							this.closeChangePswdPopup();
							this.storageSessionService.clearToken();
							this.storageSessionService.clearServiceURL();
							this.clearData();
							this.router.navigate(['login']);
						} else {
							this.clearChangePasswordForm();
							this.errorMessage = res.message;
						}
					},
					function (error: any): void {
						this.errorMessage = 'Something went wrong. Please try after some time.';
						this.clearChangePasswordForm();
					}
				);
			}
		}
	}

	clearChangePasswordForm(): void {
		this.password = '';
		this.newPassword = '';
		this.confirmPassword = '';
		this.errorMessage = '';
		this.invalidPassword = false;
		this.invalidInput = false;
	}

	getSelectedIDsURL(selectedDropdownList: any[]): string {
		let urlSelectedList = '';
		selectedDropdownList.forEach((obj, index) => {
			urlSelectedList = index === 0 ? obj.id : `${urlSelectedList},${obj.id}`;
		});
		return urlSelectedList;
	}

	setQueryParams(reloadData?: boolean): any {
		const queryParamsObject: QueryParameters = this.analyticsDataModel.getQueryParamsObj();
		if (!this.analyticsDataModel.userInteracted && JSON.stringify(queryParamsObject) !== '{}') {
			return this.getQueryParamsBeforeUserInteraction(queryParamsObject, reloadData);
		} else {
			return this.getQueryParamsAfterUserInteracted();
		}
	}

	private getQueryParamsBeforeUserInteraction(
		queryParamsObject: QueryParameters,
		reloadData?: boolean
	): QueryParameters {
		const datesSelected = this.analyticsService.processQueryParamsDateRanges(queryParamsObject);
		this.analyticsDataModel.startDate = datesSelected.startDate;
		this.analyticsDataModel.endDate = datesSelected.endDate;
		queryParamsObject.start_date = this.analyticsDataModel.startDate.format(DATEPICKER.FORMAT);
		queryParamsObject.end_date = this.analyticsDataModel.endDate.format(DATEPICKER.FORMAT);
		queryParamsObject.advertiser_ids =
			queryParamsObject.advertiser_ids === ''
				? this.getSelectedIDsURL(this.analyticsDataModel.selectedAdvertisers)
				: queryParamsObject.advertiser_ids
						.split(',')
						.filter((obj) => {
							return this.analyticsDataModel.selectedAdvertisers.map((obj1) => obj1.id).includes(obj);
						})
						.join(',');
		if (
			reloadData &&
			this.storageSessionService.reloadDataAfterLogin &&
			this.analyticsDataModel.selectedCampaigns.length > 0
		) {
			EmitterService.get(EVENT_EMITTERS.RELOAD).emit(true);
			this.storageSessionService.reloadDataAfterLogin = false;
		}
		return queryParamsObject;
	}

	private getQueryParamsAfterUserInteracted(): QueryParameters {
		const selectedAdvertisersString = this.getSelectedIDsURL(this.analyticsDataModel.selectedAdvertisers);
		const selectedCampaigns = this.analyticsDataModel.campaigns
			? this.analyticsDataModel.campaigns.filter((obj) => {
					obj.id = obj.campaignId;
					return obj.selected;
			  })
			: [];
		const selectedCampaignsString =
			selectedCampaigns.length || selectedAdvertisersString === ''
				? this.getSelectedIDsURL(selectedCampaigns)
				: this.analyticsDataModel.queryParamsCampaigns.join(',');
		const queryParamsObj: QueryParameters = {
			start_date: this.analyticsDataModel.startDate
				? `${moment(this.analyticsDataModel.startDate).format('MM-DD-YYYY')}`
				: '',
			// tslint:disable-next-line:object-literal-sort-keys
			end_date: this.analyticsDataModel.endDate
				? `${moment(this.analyticsDataModel.endDate).format('MM-DD-YYYY')}`
				: '',
			advertiser_ids: selectedAdvertisersString,
			campaign_ids: selectedCampaignsString
		};
		return queryParamsObj;
	}

	private updateQueryParams(reloadData?: boolean): void {
		this.router.navigate([], {
			queryParams: this.setQueryParams(!!reloadData),
			queryParamsHandling: 'merge',
			relativeTo: this.activatedRoute
		});
	}

	private validateAndNavigate(response: any): void {
		const responsePathStatus = this.navigationItemStatus[response.name];
		this.hideNoDataContent();
		this.hideNoDataTextR10();
		try {
			if (responsePathStatus && response.name !== PATHS.OVERVIEW) {
				const nextAvailablePath = this.getNextAvailablePathFromStatus();
				if (nextAvailablePath.length !== 0) {
					this.analyticsDataModel.setCurrentPath(nextAvailablePath);
					this.router.navigate([`/dashboard/${nextAvailablePath}`], { queryParams: this.setQueryParams() });
					EmitterService.get(EVENT_EMITTERS.NAVIGATION_DONE).emit({});
				} else {
					this.showNoDataContent();
					this.analyticsDataModel.setCurrentPath(response.name);
					EmitterService.get(EVENT_EMITTERS.NAVIGATION_DONE).emit({});
				}
			} else {
				this.analyticsDataModel.setCurrentPath(response.name);
				this.router.navigate([`/dashboard/${response.name}`], { queryParams: this.setQueryParams() });
				EmitterService.get(EVENT_EMITTERS.NAVIGATION_DONE).emit({});
			}
		} catch (e) {
			console.warn(e);
			this.router.navigate([`/dashboard/${this.config.routing.defaultRoute}`], {
				queryParams: this.setQueryParams()
			});
		}
	}

	private showNoDataContent(): void {
		jQuery('container').css('height', 400);
		jQuery('.map-no-data-container').show();
	}

	private hideNoDataContent(): void {
		jQuery('container').css('height', 'auto');
		jQuery('.map-no-data-container').hide();
	}

	private getNextAvailablePathFromStatus(): string {
		let path = '';
		const navWidgets: Widget[] = this.analyticsDataModel.config.navWidgets;
		for (const widget of navWidgets) {
			if (!this.navigationItemStatus[widget.widgetPath]) {
				path = widget.widgetPath;
				break;
			}
		}
		return path;
	}

	private showNoDataTextR10(): void {
		jQuery('.noDataText').css({ display: 'unset' });
		jQuery('.dataContent').css({ display: 'none' });
	}
	private hideNoDataTextR10(): void {
		jQuery('.noDataText').css({ display: 'none' });
		jQuery('.dataContent').css({ display: 'unset' });
	}
}
